import React, { useEffect } from "react";
import { NewDesignStyle } from "./NewDesignStyle";

// 🎨 Styles communs du design ajoutés à la page et classe « nd » sur <body> (jetons disponibles partout).
// Tour 65 : seul design du site, plus d'interrupteur « nouveau_design »
function NewDesign() {
  useEffect(() => {
    document.body.classList.add("nd");
    return () => document.body.classList.remove("nd");
  }, []);
  return <NewDesignStyle />;
}

export default NewDesign;
